export const drinksData = [
  {
    name: "Sea Trout",
    price: "$49.91",
    desc: "A small river named Duden flows by their place and supplies",
    id: "drink1",
    imgPath: "assets/images/coffee/menu-1.jpg.webp"
  },
  {
    name: "Roasted Beef",
    id: "drink2",
    price: "$20.00",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/coffee/menu-2.jpg.webp"
  },
  {
    name: "Butter Fried Chicken",
    id: "drink3",
    price: "$20.00",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/coffee/menu-3.jpg.webp"
  },
  {
    name: "Chiken Filet",
    id: "drink4",
    price: "$20.00",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/coffee/menu-4.jpg.webp"
  },
]
